import { render } from "./Aside.vue?vue&type=template&id=9f90a2bc&scoped=true"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"

import "./Aside.vue?vue&type=style&index=0&id=9f90a2bc&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\Yuegao\\vue_pro\\2003_yuebao_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f90a2bc"]])

export default __exports__